import { UserManagerSettings, WebStorageStateStore } from "oidc-client-ts";
import { AppConfig } from "./services/app-config";

function getMeta(metaName: string) {
    const metas = document.getElementsByTagName('meta');
    for (let i = 0; i < metas.length; i++) {
        if (metas[i].getAttribute('name') === metaName) {
            return metas[i].getAttribute('content');
        }
    }
    return '';
}

let estimatorSpa = getMeta('tne.estimator.spa')!;
let estimatorApi = getMeta('tne.estimator.api')!;
let costbooksApi = getMeta('tne.costbooks.api')!;
let identityServer = getMeta('tne.identity.server')!;

const config: AppConfig = {
    api: {
        estimator: estimatorApi,
        costbooks: costbooksApi,
    }
};
export function getConfig(): AppConfig {
    return config;
}
export function createOidcSettings(): UserManagerSettings {
    return {
        authority: identityServer,
        client_id: "tne.estimator.spa",
        redirect_uri: `${estimatorSpa}/callback`,
        response_type: "code",
        scope: "openid profile offline_access tne.estimator.api tne.costbooks.api",
        post_logout_redirect_uri: estimatorSpa.replace(/\/$/, "") + "/",
        automaticSilentRenew: true,
        silent_redirect_uri: `${estimatorSpa}/silentRenew`,
        accessTokenExpiringNotificationTimeInSeconds: 300,
        userStore: new WebStorageStateStore({ store: window.sessionStorage }),
        stateStore: new WebStorageStateStore({ store: window.sessionStorage })
    };
}


// WEBPACK FOOTER //
// ./ClientApp/oidcConfig.ts